import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Context } from "../../../utils/context";
import { putData } from "../../../utils/api";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const SOURCES = ["Instagram", "Facebook", "Influencer", "WhatsApp", "YouTube", "Email", "SMS", "Admin"]
  .map((source) => ({ value: source, label: source }));

const selectStyles = (hasError) => ({
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: hasError ? "red" : baseStyles.borderColor,
  }),
});

// Add and edit an offer link (edit when props.id is set)
const AddOffCanvance = (props) => {
  const { getData, postData } = useContext(Context);
  const [coupons, setCoupons] = useState([]);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const loadData = async () => {
      const response = await getData(`/admin/offer-advertisement/coupons`);
      setCoupons(
        (response?.data || []).map((coupon) => ({
          value: coupon.id,
          label: `${coupon.code} - ${coupon.name}`,
        })),
      );

      if (props.id) {
        const data = (await getData(`/admin/offer-advertisement/${props.id}`))?.data;
        reset({
          coupon_id: {
            value: data?.coupon_id,
            label: `${data?.Coupon?.code} - ${data?.Coupon?.name}`,
          },
          source: { value: data?.source, label: data?.source },
          url: data?.url,
          slug: data?.slug,
        });
      }
    };
    loadData();
  }, [props.id]);

  const onSubmit = async (data) => {
    const finalData = {
      coupon_id: data.coupon_id?.value,
      source: data.source?.value,
      url: data.url,
      slug: data.slug,
    };
    const response = props.id
      ? await putData(`/admin/offer-advertisement/${props.id}`, finalData)
      : await postData(`/admin/offer-advertisement`, finalData);

    setShowModal({
      code: response?.code || 1,
      message: response?.success ? response.message : response?.errors || "Something went wrong",
    });
    setTimeout(() => {
      setShowModal({ code: 0, message: "" });
      if (response?.success) props.handleClose();
    }, 1000);
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props.id ? "Edit" : "Add"} Offer Link
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Coupon</Form.Label>
                    <Controller
                      name="coupon_id"
                      control={control}
                      rules={{ required: "Select coupon" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={coupons}
                          placeholder="Select coupon"
                          styles={selectStyles(errors.coupon_id)}
                        />
                      )}
                    />
                    {errors.coupon_id && (
                      <span className="text-danger">{errors.coupon_id.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Source</Form.Label>
                    <Controller
                      name="source"
                      control={control}
                      rules={{
                        required: "Select or type a source",
                        validate: (option) =>
                          option?.value?.length <= 50 || "Source must be 50 characters or less",
                      }}
                      render={({ field }) => (
                        <CreatableSelect
                          {...field}
                          options={SOURCES}
                          placeholder="Select or type a source"
                          styles={selectStyles(errors.source)}
                        />
                      )}
                    />
                    {errors.source && (
                      <span className="text-danger">{errors.source.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Destination URL</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Product, category or collection page of the website, e.g. /shop/?category_id=3"
                      className={classNames("", { "is-invalid": errors?.url })}
                      {...register("url", {
                        required: "Destination URL is required",
                        maxLength: { value: 500, message: "URL must be 500 characters or less" },
                      })}
                    />
                    <Form.Text muted>
                      Open the page on the website and paste its link here.
                    </Form.Text>
                    {errors.url && (
                      <div className="text-danger">{errors.url.message}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Slug (optional)</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. insta-diwali-sale"
                      className={classNames("", { "is-invalid": errors?.slug })}
                      {...register("slug", {
                        pattern: {
                          value: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
                          message: "Use lowercase letters, numbers and hyphens only",
                        },
                        minLength: { value: 3, message: "Slug must be at least 3 characters" },
                        maxLength: { value: 100, message: "Slug must be 100 characters or less" },
                      })}
                    />
                    <Form.Text muted>
                      Leave empty to generate one. Changing it breaks links already shared.
                    </Form.Text>
                    {errors.slug && (
                      <div className="text-danger">{errors.slug.message}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton name={"cancel"} handleClose={props.handleClose} />
                  <SaveButton name={"save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
